import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initQuantityInputs from '../components/quantityInputs';
import initProductVariants from '../components/product-variants';
import initProductStickyAtc from '../components/product-sticky-atc';
import initGiftCardRecipientForm from '../components/giftCardRecipientForm';
import initKlaviyoBis from '../sections/product/klaviyo-bis';
import initRelatedProducts from '../sections/product/related-products';
import initRecentlyViewedProducts from '../sections/product/recently-viewed';
import { initGalleryVideos, initLoadMore } from '../sections/product/product-gallery';
import initProductGalleryLightbox from '../sections/product/product-gallery-lightbox';
import initSizeInfo from '../components/size-info';
import initProductChoices from '../components/product-choices';

ready(() => {
  initQuantityInputs();
  initProductVariants();
  initProductChoices();
  initRelatedProducts();
  initProductStickyAtc();
  initGiftCardRecipientForm();
  initKlaviyoBis();
  initGalleryVideos();
  initLoadMore();
  initRecentlyViewedProducts();
  initProductGalleryLightbox();
  initSizeInfo();
});

onShopifySectionLoad(() => {
  initRelatedProducts();
});
